import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { IconButton, Autocomplete } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import user_icon from '../../../../public/assets/user_icon.jpg';
import logo_between from '../../../../public/assets/logo-white.jpeg';
import { Card, CardContent, Checkbox } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import LeadService from '../../../core/services/leadsService';
import toast from 'react-hot-toast';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import logoICA from '../../../../public/assets/icoonectICA.png';
// import dayjs from 'dayjs';
import InputAdornment from '@mui/material/InputAdornment';
import EventIcon from '@mui/icons-material/Event';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
// import moment from 'moment';
import { useDateTime } from '../../../pages/ContextDateandTime/DateTimeContext';
import { useDispatch, useSelector } from 'react-redux';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { CLOSE_LEAD_MODEL, CLOSE_RE_ASSING_MODAL } from '../../../core/store/slice/icaSlice';
import Avatar from '@mui/material/Avatar';
import GooglePlacesAutocomplete, { geocodeByPlaceId, getLatLng } from 'react-google-places-autocomplete';
import { Loader } from '@googlemaps/js-api-loader';
import dayjs from 'dayjs';
const UpdateIcaMeeting = ({
    openMeetingModal,
    setOpenMeetingModal,
    leadMeetingId,
    leadAddress,
    buyerLatitude,
    buyerLongitude,
    leadDate,
    leadTime
         }) => {
            
    const [googleLocation, setGoogleLocation] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [latitude, setLatitude] = useState(null);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectTime, setSelectTime] = useState(null); 
    const [displayDate, setDisplayDate] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);
    const [loading, setLoading] = useState(false);
    const [usePropertyLocation, setUsePropertyLocation] = useState(false);

    const loader = new Loader({
        apiKey: import.meta.env.VITE_GOOGLE_API_KEY,
        version: 'weekly',
        libraries: ['places'],
    });

    const handleUpdateMeeting = async (leadMeetingId, latitude, longitude, googleLocation, selectedDate, selectTime) => {
        if (selectedValue === 0 && !googleLocation) {
            return toast.error('Please select a meeting location');
        }
         if(!selectedDate){
            return toast.error('please select a date');
         }
         if(!selectTime){
            return toast.error('please select a time');
         }
         if(selectedValue === null){
            return toast.error('please select a either a meeting location or location option');
         }
        try {
            setLoading(true);
            const time = new Date(selectTime);
            const meetingLocation = googleLocation?.label;
            const newMeetingLocation = usePropertyLocation ? leadAddress : meetingLocation;
            const newLatitude = usePropertyLocation ? buyerLatitude : latitude;
            const newLongitude = usePropertyLocation ? buyerLongitude : longitude;
            const formattedSelectTime = `${String(time.getHours()).padStart(2, '0')}:${String(time.getMinutes()).padStart(2, '0')}:${String(time.getSeconds()).padStart(2, '0')}`;
            const resp = await LeadService.GetUpdateIcaMeeting(
                leadMeetingId,
                newLatitude,
                newLongitude,
                newMeetingLocation,
                selectedDate,
                formattedSelectTime
            );
            if (resp?.data?.success) {
                toast.success(resp?.data?.message);
                handleCloseMeetingModal();
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    const handleCloseMeetingModal = () => {
        setOpenMeetingModal(false);
        setSelectedDate('');
        setSelectTime('');
        setLatitude('');
        setLongitude('');
        setGoogleLocation('');
        setSelectedValue(null)
    };
    const handlePlaceSelect = async (value) => {
        try {
            setGoogleLocation(value);
            const results = await geocodeByPlaceId(value?.value?.place_id);
            if (results && results.length > 0) {
                const { lat, lng } = await getLatLng(results[0]);
                setLatitude(lat);
                setLongitude(lng);
            }
        } catch (error) {
            console.error('Error fetching geolocation:', error);
        }
    };

    const formatDateToDisplay = (isoDate) => {
        const date = new Date(isoDate);
        return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
    };
    const handleChangeDate = (e) => {
        setSelectedDate(e.target.value);
        const formattedDisplayDate = formatDateToDisplay(e.target.value);
        setDisplayDate(formattedDisplayDate);
    };
    const getTomorrowsDate = () => {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 0);
        return tomorrow.toISOString().slice(0, 10);
    };
    const tomorrowsDate = getTomorrowsDate();

    const handleTimeChange = (time) => {
        setSelectTime(time);
    };


    const handleMainRadioChange = (e) => {
        const value = Number(e.target.value);
        setSelectedValue(value);
        
        // If "Location Options" is selected (value === 1), enable "Same as property location"
        if (value === 1) {
            setUsePropertyLocation(true);
        } else {
            setUsePropertyLocation(false);
        }
    };

    useEffect(() => {
        if (leadDate) {
            setSelectedDate(leadDate);
        }
        if (leadTime) {
            setSelectTime(dayjs(leadTime, "HH:mm"));
        }
    }, [leadDate, leadTime]);
    return (
        <div>
            <Dialog
                aria-labelledby="customized-dialog-title"
                open={openMeetingModal}
                // onClose={CloseLocation}
                sx={{
                    '& .MuiPaper-root': {
                        borderRadius: '22px',
                        boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.15)', // Modern shadow
                    },
                }}
            >
                <DialogTitle sx={{ m: 0, p: 2, textAlign: 'center' }} id="customized-dialog-title">
                    <img src={logoICA} style={{ width: '220px', display: 'flex', justifyContent: 'flex-start' }} alt="Logo" />
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseMeetingModal}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers sx={{ padding: '20px 40px' }}>
                    <Typography variant="subtitle2" sx={{ color: '#6C757D', marginBottom: '20px' }}>
                        <em>Select Appointment Date and Time</em>
                    </Typography>
                    <Box sx={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>
                        {/* Date Picker */}
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#343A40' }}>
                                Date
                            </Typography>
                            <TextField
                                margin="dense"
                                type="date"
                                value={selectedDate}
                                onChange={handleChangeDate}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    style: { height: '48px', borderRadius: '12px' },
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <EventIcon style={{ color: '#343A40' }} />
                                        </InputAdornment>
                                    ),
                                }}
                                inputProps={{
                                    min: tomorrowsDate,
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                        borderColor: '#DEE2E6',
                                    },
                                }}
                            />
                        </Box>
                        {/* Time Picker */}
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#343A40' }}>
                                Time
                            </Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                {/* <DemoContainer components={['TimePicker']}> */}
                                <TimePicker
                                    value={selectTime}
                                    onChange={handleTimeChange}
                                    sx={{
                                        width: '100%',
                                        '.MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                            height: '48px',
                                            marginTop: '9px',
                                            borderColor: '#DEE2E6',
                                        },
                                    }}
                                    // minTime={dayjs()}
                                    componentsProps={{
                                        actionBar: {
                                            actions: ['accept', 'clear', 'cancel'],
                                        },
                                    }}
                                />
                                {/* </DemoContainer> */}
                            </LocalizationProvider>
                        </Box>
                    </Box>

                    <Box style={{ display: 'grid' }}>
                        <div>
                            <FormControl sx={{ marginBottom: '20px' }}>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    row
                                    value={selectedValue} 
                                    onChange={handleMainRadioChange}
                                >
                                    <FormControlLabel value={0} control={<Radio />} label="Meeting Location" />
                                    <FormControlLabel value={1} control={<Radio />} label="Location Options" />
                                </RadioGroup>
                            </FormControl>
                        </div>
                        <div>
                            {selectedValue === 0 && (
                                <>
                                    {/* Google Places Autocomplete */}
                                    <Typography variant="subtitle2" sx={{ color: '#6C757D', marginBottom: '10px' }}>
                                        <em>Select Meeting Location*</em>
                                    </Typography>
                                    <Box sx={{ marginBottom: '20px' }}>
                                        <GooglePlacesAutocomplete
                                            selectProps={{
                                                value: googleLocation,
                                                onChange: (value) => handlePlaceSelect(value),
                                            }}
                                            apiKey={import.meta.env.VITE_GOOGLE_API_KEY}
                                        />
                                    </Box>
                                </>
                            )}
                        </div>
                        <div>
                            {selectedValue === 1 && (
                                <>
                                    <FormControl sx={{ marginBottom: '20px' }}>
                                        <RadioGroup
                                            aria-labelledby="demo-controlled-radio-buttons-group"
                                            name="controlled-radio-buttons-group"
                                            row
                                        >
                                            <FormControlLabel
                                                control={<Radio checked={usePropertyLocation} onClick={()=>setUsePropertyLocation(true)} />}
                                                label="Same as property location"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </>
                            )}
                        </div>
                    </Box>
                    {/* Find Agent Button */}
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                            onClick={() => handleUpdateMeeting(leadMeetingId, latitude, longitude, googleLocation, selectedDate, selectTime)}
                            sx={{
                                width: '100%',
                                padding: '12px',
                                fontSize: '18px',
                                borderRadius: '22px',
                                backgroundColor: '#9a9a9a',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#495057',
                                },
                            }}
                            disabled={loading}
                        >
                            {loading ? 'Loading...' : 'Edit'}
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default UpdateIcaMeeting;
